/**
 * StingBase
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PropertiesCreatedTotal200ResponseMeta } from './propertiesCreatedTotal200ResponseMeta';
import { PropertiesCreatedTotalResource } from './propertiesCreatedTotalResource';


export interface PropertiesCreatedTotal200Response { 
    data: PropertiesCreatedTotalResource;
    meta: PropertiesCreatedTotal200ResponseMeta;
}

